<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <div class="card">
            <!-- Search -->
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col-sm-4">
                  <div class="icon-form mb-3 mb-sm-0">
                    <span class="form-icon"><i class="ti ti-search"></i></span>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search Countries"
                    />
                  </div>
                </div>
                <div class="col-sm-8">
                  <div
                    class="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end"
                  >
                    
                    <button class="btn btn-primary" @click="openModal()">
                      <i class="ti ti-square-rounded-plus me-2"></i>Add
                      Competitor
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Search -->

            <div class="card-body">
              <!-- Filter -->
              <countires-filter></countires-filter>
              <!-- /Filter -->

              <!-- Countries List -->
              <div v-if="!isLoading" class="table-responsive custom-table">
                <a-table
                  class="table"
                  :columns="columns"
                  :data-source="data"
                  :row-selection="rowSelection"
                  row-key="id"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'action'">
                      <div class="dropdown table-action">
                        <a
                          href="#"
                          class="action-icon"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          ><i class="fa fa-ellipsis-v"></i
                        ></a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="openModal(record)"
                            ><i class="ti ti-edit text-blue"></i> Edit</a
                          ><a
                            class="dropdown-item"
                            href="#"
                            @click="openDeleteModal(record)"
                            ><i class="ti ti-trash text-danger"></i> Delete</a
                          >
                        </div>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>

              <!-- Loading indicator -->
              <div v-else>
                <p>Loading...</p>
              </div>

              <div class="row align-items-center">
                <div class="col-md-6">
                  <div class="datatable-length"></div>
                </div>
                <div class="col-md-6">
                  <div class="datatable-paginate"></div>
                </div>
              </div>
              <!-- /Countries List -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <competitor-list-modal
    v-if="isShowModal"
    @refresh="refresh"
    :isEditMode="isEditMode"
    :title="title"
  />
</template>

<script>
import http from "@/utils/http";

export default {
  data() {
    return {
      title: "Competitors",
      data: [],
      isLoading: true,
      isEditMode: false,
      isShowModal: false,
      columns: [
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
          sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
          title: "Remarks",
          dataIndex: "remarks",
          key: "remarks",
          sorter: (a, b) => a.remarks.localeCompare(b.remarks),
        },
        {
          title: "Action",
          key: "action",
        },
      ],
      rowSelection: {
        onChange: () => {},
        onSelect: () => {},
        onSelectAll: () => {},
      },
    };
  },
  mounted() {
    this.getCollections();
  },
  methods: {
    async getCollections() {
      this.isLoading = true;
      try {
        const response = await http.get("competitors");
        this.data = response.data.contents;
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isLoading = false;
      }
    },
     refresh() {
      this.isShowModal = false;
      this.getCollections();
    },
    openModal(row = "") {
      this.isShowModal = true;
      this.isEditMode = !!row.id;
      setTimeout(() => {
        this.$emitter.emit("add-edit-item", row);
      });
    },
    openDeleteModal(row = "") {
      this.isShowModal = true;
      setTimeout(() => {
        this.$emitter.emit("delete-item-modal", row);
      });
    },
  },
};
</script>
